import { Component, Input, OnInit, Pipe, PipeTransform } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse  } from '@angular/common/http';
import { NgxSpinnerService } from "ngx-spinner";
import { LocalStorageService } from 'ngx-webstorage';
import { FunctService } from '../../services/funct.service';
import { catchError, retry } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { DtoService } from '../../services/dto.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import isUAWebview from "is-ua-webview";
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-banner-ads',
  templateUrl: './app-banner-ads.component.html',
  styleUrls: ['./app-banner-ads.component.scss']
})
  
export class AppBannerAdsComponent {

  @Input() gameProviderId: any;
  @Input() gameType: any;
  @Input() startTime: any;

  gameProviderList: any = [];
  providerListId: any;
  adsList: any;
  marqueeText: any;
  customOptions: OwlOptions = {    
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    items:1,
    autoplay: true,
    autoplayTimeout: 5000,
    animateOut: false,
    navSpeed: 100,
    autoHeight: true,
    navText: ['', ''],
    responsive: {
      400: {
        items: 1 
      }
    }
  }
  isWebview: boolean;
  openUrl: string;
  deviceId: any;
  refreshLoading: any;

  constructor(
    public common: CommonService,
    private storage: LocalStorageService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private http: HttpClient,
    private dto: DtoService,
    private router: Router,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private funct: FunctService) {
    
      this.deviceId = this.storage.retrieve('localDeviceId'); 
      this.isWebview = isUAWebview(navigator.userAgent);
    
      if(navigator.userAgent.indexOf("Mi") != -1 && this.isWebview ){
        this.openUrl = "";
      }
      if(this.deviceId !=null || this.isWebview){
        this.openUrl = ""; //&?openinnewtap=1
      }
      else{
        this.openUrl = "";
      }
      this.gameProviderList = this.storage.retrieve("localGameProviderList");
  }
  
  ngOnInit() {
    this.refreshLoading=true;
    this.spinner.show("refreshLoading");

    if (this.gameProviderId == 0) 
    {
      this.providerListId = 0;
    } else 
    {
      if (this.gameProviderList != null && this.gameProviderList != undefined && this.gameProviderList != "") 
      {
        this.providerListId = this.gameProviderList.find(x =>
          x.provider_id.toString() === this.gameProviderId.toString() &&
          (!x.g_type || x.g_type.trim().toLowerCase() === this.gameType?.trim().toLowerCase())
      )?.id;    
      }
    }

    this.getAdsList();
    this.getMarqueeText();
  }

  getAdsList() {

    let headers = new HttpHeaders();
    let params = new HttpParams();

    params = params.set('gameProviderId', this.providerListId);

    this.http.get(this.funct.ipaddress + 'ads/GetAdsList', { params:params, headers: headers })
    .pipe(
      catchError(this.handleError.bind(this))
    )
    .subscribe(
      result => {      
        this.dto.Response = result;
        this.adsList =  this.dto.Response;
        this.refreshLoading = false;
        this.spinner.hide("refreshLoading");
    });
  }

  getMarqueeText() {

    let headers = new HttpHeaders();

    let params = new HttpParams();
    params = params.set('providerId', this.providerListId);
    this.http.get(this.funct.ipaddress + 'marquee/getMarqueeText', { params:params, headers: headers })
    .pipe(
      catchError(this.handleError.bind(this))
    )
    .subscribe(
      result => {
        this.dto.Response = {};
        this.dto.Response = result;
        this.marqueeText =  this.dto.Response;
        this.refreshLoading = false;
        this.spinner.hide("refreshLoading");
    });
  }

  handleError(error: HttpErrorResponse) {

    this.refreshLoading = false;
    this.spinner.hide("refreshLoading");
    if (error.status == 423) {
      this.common.errorMsg("", "youNeedLogin", "top");
      return;

    } else if (error.status == 400) {
      this.common.errorMsg("", "bad_request", "top");
      return;

    } else {
      this.common.errorMsg("", "server_error", "top");
      return;
      
    }
   
  }

}